import Da from "../../../assets/flags/danmark_flag.svg";
import En from "../../../assets/flags/uk_flag.svg";
import Fr from "../../../assets/flags/france_flag.svg";
import De from "../../../assets/flags/germany_flag.svg";
import Es from "../../../assets/flags/spain_flag.svg";

import { FlagNames } from "../../../enums/flag.enums";

const ActualIcon = ({ name }: { name: FlagNames }) => {
    let iconSrc;

    switch (name) {
        case FlagNames.Da:
            iconSrc = Da;
            break;
        case FlagNames.En:
            iconSrc = En; // You can change this to Uk if you prefer the UK flag for all English variants
            break;
        case FlagNames.Fr:
            iconSrc = Fr;
            break;
        case FlagNames.De:
            iconSrc = De;
            break;
        case FlagNames.Es:
            iconSrc = Es;
            break;
        default:
            iconSrc = "";
    }

    return <img role="presentation" src={iconSrc} alt={`${name} icon`} />;
};

export default ActualIcon;
